export default "__VITE_ASSET__9b917537__"